import { useEffect } from 'react'

import { useAsyncError } from '@/modules/errors'
import { useCaseConfigStore } from '../stores/caseConfig'

export const useCaseConfigIsLoaded = () =>
  useCaseConfigStore((state) => state.isLoaded)

export const useCaseConfigIsLoading = () =>
  useCaseConfigStore((state) => state.isLoading)

export const useCaseTypes = () => useCaseConfigStore((state) => state.caseTypes)

export const useCaseAccountTypes = () =>
  useCaseConfigStore((state) => state.accountTypes)

export const useCaseConfigLoaders = () =>
  useCaseConfigStore((state) => state.loaders)

export const useFetchCaseConfig = () => {
  const { fetchCaseConfig } = useCaseConfigLoaders()
  const throwError = useAsyncError()

  useEffect(() => {
    fetchCaseConfig().catch(throwError)
  }, [])
}
